import { useTranslation } from 'react-i18next';
import { StatusPill } from '../ui/status-pill';

export const AwaitingFirstPaymentChip = () => {
  const { t } = useTranslation();
  return (
    <StatusPill
      color="bg-amber-100 text-amber-700"
      label={t('policyStatus.AWAITING_FIRST_PAYMENT')}
    />
  );
};
